<table class="table">
  <thead>
    <tr>
      <th>{{ "common.id" | translate }}</th>
      <th>{{ "common.productName" | translate }}</th>
      <th>{{ "common.totalOrders" | translate }}</th>
      <th>{{ "package.total-packages" | translate }}</th>
      <th>{{ "common.stock" | translate }}</th>
    </tr>
  </thead>
  <tbody *ngIf="item">
    <tr *ngFor="let line of item.variants">
      <td>{{ line.id }}</td>
      <td class="flex flex-row" style="justify-content: center">
        <div>
          <a
            class="button-ghost"
            [routerLink]="['/catalog/products', item.id, 'variants', line.id]"
          >
            <span class="limit-name">
              {{ line.name }}
            </span>
            <clr-icon shape="arrow right" />
          </a>
        </div>
      </td>

      <td>{{ line.totalOrder }}</td>
      <td>{{ line.totalPackage }}</td>
      <td>
        {{ line.stock }}
      </td>
    </tr>
  </tbody>
</table>
